var v1='<div><div id=TestKitsApp></div></div>';
angular.module('account.templates').run(['$templateCache', function ($templateCache) {$templateCache.put('src/app/test-kits/test-kits.html', v1);}]);
module.exports=v1